/* Ellipse 292 */

import CowIconIcon from "common/icons/CowIcon";
import styled from "styled-components";

const Circle = styled.span`
  background: #b69bde;
  text-align: center;
  display: inline-block;
  height: 80px;
  width: 80px;
  border-radius: 50%;
  vertical-align: middle;
  line-height: 80px;
`;

export default function CowInCircle() {
  return (
    <Circle>
      <CowIconIcon></CowIconIcon>
    </Circle>
  );
}
